var map = {
	"./CheckoutWidget": [
		1061,
		3
	],
	"./CheckoutWidget.js": [
		1061,
		3
	],
	"./KlarnaCheckout": [
		1099,
		2
	],
	"./KlarnaCheckout.js": [
		1099,
		2
	],
	"./PaymentWidget": [
		1067
	],
	"./PaymentWidget.js": [
		1067
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1113;
module.exports = webpackAsyncContext;